import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import { Card } from "../components/ui/card";
import { Send } from "lucide-react";
import { TransferForm } from "../components/TransferForm";
import { brl } from "../components/PurchaseDialog";

const WalletHistory = ({ items }) => (
  items.length === 0 ? <p className="text-xs text-muted-foreground" data-testid="wallet-empty">Nenhuma movimentação ainda.</p> : (
    <div className="divide-y divide-border/60" data-testid="wallet-history">
      {items.map((e) => (
        <div key={e.id} className="flex items-center justify-between gap-3 py-2 text-sm" data-testid={`wallet-item-${e.id}`}>
          <div className="min-w-0">
            <div className="font-medium">{e.type_label}</div>
            <div className="text-xs text-muted-foreground truncate">{e.description} · {new Date(e.created_at).toLocaleString("pt-BR")}</div>
          </div>
          <span className={`font-mono whitespace-nowrap ${e.direction === "credit" ? "text-emerald-500" : "text-rose-500"}`}>
            {e.direction === "credit" ? "+" : "−"} {brl(e.amount)}
          </span>
        </div>
      ))}
    </div>
  )
);

export default function Transfer() {
  const [w, setW] = useState(null);
  const load = useCallback(() => { api.get("/wallet").then((r) => setW(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-24 pb-16 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Carteira</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold mt-1 mb-8">Transferir <span className="gold-text">saldo</span></h1>
        {!w ? <p className="text-muted-foreground">Carregando...</p> : (
          <div className="grid lg:grid-cols-5 gap-6">
            <Card className="p-6 lg:col-span-2 gold-border h-fit" data-testid="transfer-balance-card">
              <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-muted-foreground"><Send className="h-4 w-4" /> Saldo disponível</div>
              <div className="mt-2 font-mono text-3xl font-bold gold-text" data-testid="transfer-available">{brl(w.balance)}</div>
              <ul className="mt-4 space-y-1 text-xs text-muted-foreground">
                <li>Taxa por transferência: <b className="text-foreground">{brl(w.fee)}</b> (descontada de você)</li>
                <li>O destinatário recebe o valor integral.</li>
                <li>Mínimo: <b className="text-foreground">{brl(w.min)}</b> · Limite diário: <b className="text-foreground">{brl(w.daily_limit)}</b></li>
                <li data-testid="transfer-sent-today">Enviado hoje: {brl(w.sent_today)}</li>
              </ul>
            </Card>
            <Card className="p-6 lg:col-span-3"><TransferForm w={w} onDone={load} /></Card>
            <Card className="p-6 lg:col-span-5">
              <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">Histórico de movimentações</div>
              <WalletHistory items={w.items} />
            </Card>
          </div>
        )}
      </div>
    </div>
  );
}
